import React from 'react'
import {
  Table, TableBody, TableCell, TableContainer,
  TableFooter,
  TableHead, TableRow,
  Tooltip
} from '@mui/material'
import AuthError from '../../../../components/ErrorComponents/AuthError'

const StickyTable = ({ columns = [], rows = [], className = '', testId = '', freezColumns = 0 }: any): JSX.Element => {
  const formatTextWithTooltip = (text: string): JSX.Element => {
    if (text?.length > 20) {
      return (<Tooltip title={text}><span>{`${text}`}</span></Tooltip>)
    }
    return <span>{text}</span>
  }

  const leftOffsets = columns
    .slice(0, freezColumns)
    .reduce((acc: any[], col: any, idx: number) => {
      const prev = acc[idx - 1] ?? 0
      acc.push(Number(prev) + 150)
      return acc
    }, [])

  const stickySx = (index: number, isHeader: boolean): any => {
    if (index >= freezColumns) return {}
    // leftOffsets stores cumulative widths; for the current column, use the previous sum
    const left = index === 0 ? 0 : leftOffsets[index - 1]
    return {
      position: 'sticky',
      left,
      // Ensure stickies sit above regular cells; header above body
      zIndex: isHeader ? 3 : 2,
      // Background so overlapping looks clean
      bgcolor: 'background.paper'
    }
  }

  return (
    <TableContainer sx={{
      maxHeight: 300,
      backgroundColor: '#3B3B3B'
    }}>
      <Table stickyHeader aria-label="sticky header & sticky columns table">
        <TableHead>
          <TableRow>
            {columns.map((col: any, idx: any) => (
              <TableCell
                key={col}
                style={{
                  border: 'none',
                  fontFamily: 'Honeywell Sans Web',
                  color: '#D0D0D0',
                  backgroundColor: '#3B3B3B',
                  padding: '8px',
                  fontSize: '15px',
                  minWidth: 150
                }}
                sx={{
                  ...(idx < freezColumns ? { minWidth: 150 } : {}),
                  fontWeight: 600,
                  ...stickySx(idx, true),
                  top: 0 // ensure stickiness for header when used with sticky columns
                }}
              >
                {col}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody data-testid={testId}>
          {rows?.map((row: any, index: number) => (
            <TableRow hover key={index}>
              {row?.length > 0 && row?.map((text: any, index: number) => (
                    <>
                    <TableCell
                  key={index}
                  sx={{
                    ...(index < freezColumns ? { minWidth: 150 } : {}),
                    ...stickySx(index, false)
                  }}
                  style={{
                    border: 'none',
                    fontFamily: 'Honeywell Sans Web',
                    color: '#D0D0D0',
                    backgroundColor: '#3B3B3B',
                    padding: '8px',
                    fontSize: '15px',
                    minWidth: 150
                  }}
                >
                  {formatTextWithTooltip(text)}
                </TableCell>
                    </>
              ))}
            </TableRow>
          ))}
          {rows?.length === 0 && (
            <TableRow>
                <TableCell className='nodatarow' style={{
                  border: 'none',
                  fontFamily: 'Honeywell Sans Web',
                  color: '#D0D0D0',
                  backgroundColor: '#3B3B3B',
                  padding: '8px',
                  fontSize: '15px',
                  width: '10%',
                  position: 'static'
                }}
                  colSpan={20} align='center'>
                    <AuthError errorMessage="NoDataPresent" />
                </TableCell>
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
            <TableRow>
                <TableCell
                 style={{
                   border: 'none',
                   height: '20px'
                 }}>

                </TableCell>
            </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  )
}

export default StickyTable
